import { useSelector } from 'react-redux';
import type { RootState } from 'app/store';

export default function useSelectedPharmacy(): RootState['pharmacySelector']['selectedPharmacy'] {
  const { selectedPharmacy } = useSelector((state: RootState) => state.pharmacySelector);

  return selectedPharmacy;
}
